import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/internal/operators/tap';
import { environment } from 'environments/environment';

export class TimingInterceptor implements HttpInterceptor {
  constructor(
    // private logger: LoggerService
  ) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const started = Date.now();

    return next
      .handle(req)
      .pipe(
        tap(event => {
          if (event instanceof HttpResponse) {
            const elapsed = Date.now() - started;
            if (environment.timeInterceptorDebug) {
              console.log(`Request for ${req.urlWithParams} took ${elapsed} ms.`);
            }
            if (event.status === 200) {
              event.body.status = 200;
              event.body.code = 'OK';
            }
          }
        }));
  }
}
